const LEAL_COLORS = 'secondary-60';
var LealColorsType;
(function (LealColorsType) {
    LealColorsType["Primary"] = "primary";
    LealColorsType["Primary0"] = "primary-0";
    LealColorsType["Primary1"] = "primary-1";
    LealColorsType["Primary2"] = "primary-2";
    LealColorsType["Primary3"] = "primary-3";
    LealColorsType["Primary4"] = "primary-4";
    LealColorsType["Primary5"] = "primary-5";
    LealColorsType["Primary6"] = "primary-6";
    LealColorsType["Primary7"] = "primary-7";
    LealColorsType["Primary8"] = "primary-8";
    LealColorsType["Primary9"] = "primary-9";
    LealColorsType["Primary10"] = "primary-10";
    LealColorsType["Secondary8"] = "secondary-8";
    LealColorsType["Secondary20"] = "secondary-20";
    LealColorsType["Secondary40"] = "secondary-40";
    LealColorsType["Secondary60"] = "secondary-60";
    LealColorsType["Secondary100"] = "secondary-100";
    LealColorsType["White"] = "white";
    LealColorsType["White20"] = "white-20";
    LealColorsType["White50"] = "white-50";
    LealColorsType["White75"] = "white-75";
    LealColorsType["White100"] = "white-100";
    LealColorsType["Tertiary0"] = "tertiary-0";
    LealColorsType["Tertiary1"] = "tertiary-1";
    LealColorsType["Tertiary2"] = "tertiary-2";
    LealColorsType["Tertiary3"] = "tertiary-3";
    LealColorsType["Tertiary4"] = "tertiary-4";
    LealColorsType["Tertiary5"] = "tertiary-5";
    LealColorsType["Tertiary6"] = "tertiary-6";
    LealColorsType["Tertiary7"] = "tertiary-7";
    LealColorsType["Tertiary8"] = "tertiary-8";
    LealColorsType["Tertiary9"] = "tertiary-9";
    LealColorsType["Tertiary10"] = "tertiary-10";
    LealColorsType["Blue0"] = "blue-0";
    LealColorsType["Blue1"] = "blue-1";
    LealColorsType["Blue2"] = "blue-2";
    LealColorsType["Blue3"] = "blue-3";
    LealColorsType["Blue4"] = "blue-4";
    LealColorsType["Blue5"] = "blue-5";
    LealColorsType["Blue6"] = "blue-6";
    LealColorsType["Blue7"] = "blue-7";
    LealColorsType["Blue8"] = "blue-8";
    LealColorsType["Blue9"] = "blue-9";
    LealColorsType["Blue10"] = "blue-10";
    LealColorsType["BlueBg"] = "blue-bg";
    LealColorsType["BlueChart1"] = "blue-chart-1";
    LealColorsType["BlueChart2"] = "blue-chart-2";
    LealColorsType["BlueChart3"] = "blue-chart-3";
    LealColorsType["BlueChart4"] = "blue-chart-4";
    LealColorsType["BlueChart5"] = "blue-chart-5";
    LealColorsType["BlueChart6"] = "blue-chart-6";
    LealColorsType["BlueIcon"] = "blue-icon";
    LealColorsType["BlueLink"] = "blue-link";
    LealColorsType["Green0"] = "green-0";
    LealColorsType["Green1"] = "green-1";
    LealColorsType["Green2"] = "green-2";
    LealColorsType["Green3"] = "green-3";
    LealColorsType["Green4"] = "green-4";
    LealColorsType["Green5"] = "green-5";
    LealColorsType["Green6"] = "green-6";
    LealColorsType["Green7"] = "green-7";
    LealColorsType["Green8"] = "green-8";
    LealColorsType["Green9"] = "green-9";
    LealColorsType["Green10"] = "green-10";
    LealColorsType["GreenBgIcon"] = "green-bg-icon";
    LealColorsType["GreenChar"] = "green-chart";
    LealColorsType["GreenChart2"] = "green-chart-2";
    LealColorsType["Orange0"] = "orange-0";
    LealColorsType["Orange1"] = "orange-1";
    LealColorsType["Orange2"] = "orange-2";
    LealColorsType["Orange3"] = "orange-3";
    LealColorsType["Orange4"] = "orange-4";
    LealColorsType["Orange5"] = "orange-5";
    LealColorsType["Orange6"] = "orange-6";
    LealColorsType["Orange7"] = "orange-7";
    LealColorsType["Orange8"] = "orange-8";
    LealColorsType["Orange9"] = "orange-9";
    LealColorsType["Orange10"] = "orange-10";
    LealColorsType["Red0"] = "red-0";
    LealColorsType["Red1"] = "red-1";
    LealColorsType["Red2"] = "red-2";
    LealColorsType["Red3"] = "red-3";
    LealColorsType["Red4"] = "red-4";
    LealColorsType["Red5"] = "red-5";
    LealColorsType["Red6"] = "red-6";
    LealColorsType["Red7"] = "red-7";
    LealColorsType["Red8"] = "red-8";
    LealColorsType["Red9"] = "red-9";
    LealColorsType["Red10"] = "red-10";
    LealColorsType["Gray0"] = "gray-0";
    LealColorsType["Gray1"] = "gray-1";
    LealColorsType["Gray2"] = "gray-2";
    LealColorsType["Gray3"] = "gray-3";
    LealColorsType["Gray4"] = "gray-4";
    LealColorsType["Gray5"] = "gray-5";
    LealColorsType["Gray6"] = "gray-6";
    LealColorsType["Gray7"] = "gray-7";
    LealColorsType["Gray8"] = "gray-8";
    LealColorsType["Gray9"] = "gray-9";
    LealColorsType["Gray10"] = "gray-10";
    LealColorsType["Purple0"] = "purple-0";
    LealColorsType["Purple1"] = "purple-1";
    LealColorsType["Purple2"] = "purple-2";
    LealColorsType["Purple3"] = "purple-3";
    LealColorsType["Purple4"] = "purple-4";
    LealColorsType["Purple5"] = "purple-5";
    LealColorsType["Purple6"] = "purple-6";
    LealColorsType["Purple7"] = "purple-7";
    LealColorsType["Purple8"] = "purple-8";
    LealColorsType["Purple9"] = "purple-9";
    LealColorsType["Purple10"] = "purple-10";
    LealColorsType["Purple11"] = "purple-11";
    LealColorsType["PurpleTooltip"] = "purple-tooltip";
    LealColorsType["PurpleBagde"] = "purple-badge";
    LealColorsType["Pink0"] = "pink-0";
    LealColorsType["Pink1"] = "pink-1";
    LealColorsType["Pink2"] = "pink-2";
    LealColorsType["Pink3"] = "pink-3";
    LealColorsType["Pink4"] = "pink-4";
    LealColorsType["Pink5"] = "pink-5";
    LealColorsType["Pink6"] = "pink-6";
    LealColorsType["Pink7"] = "pink-7";
    LealColorsType["Pink8"] = "pink-8";
    LealColorsType["Pink9"] = "pink-9";
    LealColorsType["Pink10"] = "pink-10";
    LealColorsType["SuccessPrimary"] = "success-primary";
    LealColorsType["SucessDarken"] = "success-darken";
    LealColorsType["SucessDark"] = "success-dark";
    LealColorsType["SucessMedium"] = "success-medium";
    LealColorsType["SucessLight"] = "success-light";
    LealColorsType["DangerPrimary"] = "danger-primary";
    LealColorsType["DangerDarken"] = "danger-darken";
    LealColorsType["DangerDark"] = "danger-dark";
    LealColorsType["DangerMedium"] = "danger-medium";
    LealColorsType["DangerLight"] = "danger-light";
    LealColorsType["WarningPrimary"] = "warning-primary";
    LealColorsType["WarningDarken"] = "warning-darken";
    LealColorsType["WarningDark"] = "warning-dark";
    LealColorsType["WarningMedium"] = "warning-medium";
    LealColorsType["WarningLight"] = "warning-light";
    LealColorsType["NeutralPrimary"] = "neutral-primary";
    LealColorsType["NeutralDarken"] = "neutral-darken";
    LealColorsType["NeutralDark"] = "neutral-dark";
    LealColorsType["NeutralMedium"] = "neutral-medium";
    LealColorsType["NeutralLight"] = "neutral-light";
    LealColorsType["YellowBgIcon"] = "yellow-bg-icon";
    LealColorsType["YellowChart"] = "yellow-chart";
    LealColorsType["YellowIcon"] = "yellow-icon";
    LealColorsType["Yellow50"] = "yellow-50";
    LealColorsType["Yellow100"] = "yellow-100";
    LealColorsType["Yellow200"] = "yellow-200";
    LealColorsType["Yellow300"] = "yellow-300";
    LealColorsType["Yellow400"] = "yellow-400";
    LealColorsType["Yellow500"] = "yellow-500";
    LealColorsType["Yellow600"] = "yellow-600";
    LealColorsType["Yellow700"] = "yellow-700";
    LealColorsType["Yellow800"] = "yellow-800";
    LealColorsType["Yellow900"] = "yellow-900";
    LealColorsType["Black8"] = "black-8";
    LealColorsType["Black20"] = "black-20";
    LealColorsType["Black40"] = "black-40";
    LealColorsType["Black60"] = "black-60";
    LealColorsType["Black100"] = "black-100";
    LealColorsType["Grey40"] = "grey-40";
    LealColorsType["Grey50"] = "grey-50";
    LealColorsType["Grey100"] = "grey-100";
    LealColorsType["Grey200"] = "grey-200";
    LealColorsType["Grey300"] = "grey-300";
    LealColorsType["Grey400"] = "grey-400";
    LealColorsType["Grey500"] = "grey-500";
    LealColorsType["Grey600"] = "grey-600";
    LealColorsType["Grey700"] = "grey-700";
    LealColorsType["Grey800"] = "grey-800";
    LealColorsType["Grey900"] = "grey-900";
    LealColorsType["GreyData"] = "grey-data";
    LealColorsType["GreyCalendar"] = "grey-calendar";
    LealColorsType["Info"] = "info";
    LealColorsType["Info50"] = "info-50";
    LealColorsType["Info100"] = "info-100";
    LealColorsType["Info200"] = "info-200";
    LealColorsType["Info300"] = "info-300";
    LealColorsType["Info400"] = "info-400";
    LealColorsType["Info500"] = "info-500";
    LealColorsType["Info600"] = "info-600";
    LealColorsType["Info700"] = "info-700";
    LealColorsType["Info800"] = "info-800";
    LealColorsType["Info900"] = "info-900";
    LealColorsType["Sa"] = "sa";
    LealColorsType["Sa50"] = "sa-50";
    LealColorsType["Sa100"] = "sa-100";
    LealColorsType["Sa200"] = "sa-200";
    LealColorsType["Sa300"] = "sa-300";
    LealColorsType["Sa400"] = "sa-400";
    LealColorsType["Sa500"] = "sa-500";
    LealColorsType["Sa600"] = "sa-600";
    LealColorsType["Sa700"] = "sa-700";
    LealColorsType["Sa800"] = "sa-800";
    LealColorsType["Sa900"] = "sa-900";
    LealColorsType["Wa"] = "wa";
    LealColorsType["Wa50"] = "wa-50";
    LealColorsType["Wa100"] = "wa-100";
    LealColorsType["Wa200"] = "wa-200";
    LealColorsType["Wa300"] = "wa-300";
    LealColorsType["Wa400"] = "wa-400";
    LealColorsType["Wa500"] = "wa-500";
    LealColorsType["Wa600"] = "wa-600";
    LealColorsType["Wa700"] = "wa-700";
    LealColorsType["Wa800"] = "wa-800";
    LealColorsType["Wa900"] = "wa-900";
    LealColorsType["A"] = "a";
    LealColorsType["A50"] = "a-50";
    LealColorsType["A100"] = "a-100";
    LealColorsType["A200"] = "a-200";
    LealColorsType["A300"] = "a-300";
    LealColorsType["A400"] = "a-400";
    LealColorsType["A500"] = "a-500";
    LealColorsType["A600"] = "a-600";
    LealColorsType["A700"] = "a-700";
    LealColorsType["A800"] = "a-800";
    LealColorsType["A900"] = "a-900";
    LealColorsType["Puntos"] = "puntos";
    LealColorsType["Puntos50"] = "puntos-50";
    LealColorsType["Puntos100"] = "puntos-100";
    LealColorsType["Puntos200"] = "puntos-200";
    LealColorsType["Puntos300"] = "puntos-300";
    LealColorsType["Puntos400"] = "puntos-400";
    LealColorsType["Puntos500"] = "puntos-500";
    LealColorsType["Puntos600"] = "puntos-600";
    LealColorsType["Puntos700"] = "puntos-700";
    LealColorsType["Puntos800"] = "puntos-800";
    LealColorsType["Puntos900"] = "puntos-900";
    LealColorsType["Bonos"] = "bonos";
    LealColorsType["Bonos50"] = "bonos-50";
    LealColorsType["Bonos100"] = "bonos-100";
    LealColorsType["Bonos200"] = "bonos-200";
    LealColorsType["Bonos300"] = "bonos-300";
    LealColorsType["Bonos400"] = "bonos-400";
    LealColorsType["Bonos500"] = "bonos-500";
    LealColorsType["Bonos600"] = "bonos-600";
    LealColorsType["Bonos700"] = "bonos-700";
    LealColorsType["Bonos800"] = "bonos-800";
    LealColorsType["Bonos900"] = "bonos-900";
    LealColorsType["Fucsia"] = "fucsia";
    LealColorsType["Fucsia50"] = "fucsia-50";
    LealColorsType["Fucsia100"] = "fucsia-100";
    LealColorsType["Fucsia200"] = "fucsia-200";
    LealColorsType["Fucsia300"] = "fucsia-300";
    LealColorsType["Fucsia400"] = "fucsia-400";
    LealColorsType["Fucsia500"] = "fucsia-500";
    LealColorsType["Fucsia600"] = "fucsia-600";
    LealColorsType["Fucsia700"] = "fucsia-700";
    LealColorsType["Fucsia800"] = "fucsia-800";
    LealColorsType["Fucsia900"] = "fucsia-900";
    LealColorsType["Accents"] = "accents";
    LealColorsType["SalmonIcon"] = "salmon-icon";
    LealColorsType["RoseIcon"] = "rose-icon";
    LealColorsType["Icons"] = "icons";
    LealColorsType["Dark"] = "dark";
    LealColorsType["Light"] = "light";
    LealColorsType["Gray"] = "gray";
    LealColorsType["Black"] = "black";
    LealColorsType["DarkGray"] = "darkgray";
    LealColorsType["HoverFocus"] = "hover-focus";
    LealColorsType["ButtonLink"] = "button-link";
})(LealColorsType || (LealColorsType = {}));

export { LEAL_COLORS as L, LealColorsType as a };
